import axios from "axios";
import { getToken } from "./user-service";

/**
 * Fetch linked flight data by flight key.
 * @param {string|number} flightKey
 * @returns {Promise<Array>} Array of linked flight documents
 */
export const getLinkedFlightByKey = async (flightKey) => {

    //console.log('getting linked flight by key:', flightKey);
    if (!flightKey) {
        throw new Error("flightKey is required to fetch linked flight information");
    }

    const token = await getToken();
    const encodedKey = encodeURIComponent(flightKey);
    const url = `/api/v1/flights/flight-search/flightkey/${encodedKey}`;

   // console.log('linked flight url:', url);

    try {
        const response = await axios.get(url, {
            headers: { "Firebase-UID": token },
        });

        if (response.status >= 400) {
            throw new Error("Error fetching linked flight information");
        }

        //console.log('linked flight response:', response.data);

        return response.data;
    } catch (e) {
        console.error("Error fetching linked flight information:", e);
        throw new Error(e.response?.data?.errors?.[0]?.msg || "Failed to fetch linked flight information");
    }
};

